@if (isLoading() && !hasError()) {
  <div class="loader-overlay">
    <optima-progress-indicator
      [view]="ProcessProgressView.Shimmer"
      [config]="{ shimmer: { variant: ShimmerVariant.Custom, items: [
        { width: '100%', height: '100%' }
      ] } }">
    </optima-progress-indicator>
  </div>
} @else if (hasError()) {
  <div class="error-container">
    <div class="error-icon">⚠️</div>
    <h3>Error Loading Whiteboard</h3>
    <p>{{ errorMessage() }}</p>
    <button (click)="onWhiteboardClose()" class="back-button">Go Back</button>
  </div>
} @else if (whiteBoardEntity()) {
  <!-- Whiteboard component from library will be rendered here -->
  <lib-whiteboard
    #template
    [entity]="whiteBoardEntity()!"
    [maxWhiteboardFileSizeMb]="maxWhiteboardFileSizeMb"
    [maxImageUploadSizeMb]="maxImageUploadSizeMb"
    (close)="onWhiteboardClose()"
    (delete)="handleDelete($event)">
  </lib-whiteboard>
} @else {
  <div class="empty-container">
    <p>Unable to load whiteboard content</p>
    <button (click)="onWhiteboardClose()" class="back-button">Go Back</button>
  </div>
}
